module.exports = __webpack_public_path__ + "static/media/logo300.cb15c29f.png";